import { BarChart3, IndianRupee, ShoppingBag, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

interface StatCardProps {
  stats: {
    bookings: number;
    orders: number;
    newUsers: number;
    totalAmount: number;
  };
}

export const StatCards = ({ stats }: StatCardProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="p-6 bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText rounded-xl shadow flex items-center gap-4">
          <BarChart3 size={36} className="text-blue-500" />
          <div>
            <p className="text-sm">{t("Bookings")}</p>
            <p className="text-2xl font-semibold">{stats.bookings}</p>
          </div>
        </div>

        <div className="p-6 bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText rounded-xl shadow flex items-center gap-4">
          <ShoppingBag size={36} className="text-green-500" />
          <div>
            <p className=" text-sm">{t("Product Purchases")}</p>
            <p className="text-2xl font-semibold">{stats.orders}</p>
          </div>
        </div>

        <div className="p-6 bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText rounded-xl shadow flex items-center gap-4">
          <Users size={36} className="text-orange-500" />
          <div>
            <p className="text-sm">{t("New Users")}</p>
            <p className="text-2xl font-semibold">{stats.newUsers}</p>
          </div>
        </div>
      </div>
      <div className="mt-6 grid grid-cols-1">
        <div className="p-6 bg-popupLight dark:bg-popupDark dark:text-primaryTextDark text-primaryText rounded-xl shadow flex items-center gap-4">
          <IndianRupee size={36} className="text-purple-500" />
          <div>
            <p className="text-sm">{t("Total Revenue")}</p>
            <p className="text-3xl font-bold">₹{stats.totalAmount}</p>
          </div>
        </div>
      </div>
    </>
  );
};
